export default __webpack_public_path__ + "static/media/Guide2.578844f3.jpg";